import { Text, Notice } from 'braid-design-system';

interface Props {
  index: number;
  errorMessage: string;
}

export const ErrorMessage = ({ index, errorMessage }: Props) => (
  <Notice data={{ automation: `error-message-${index}` }} tone="critical">
    <Text>{errorMessage}</Text>
  </Notice>
);
